import i18n from '@/utils/i18n';
import { Alert } from 'react-native';
import { getOperationName } from 'apollo-utilities';
import { gql, useMutation } from '@apollo/client';
import {
  Supplier_DeactivateRestaurantMutation,
  Supplier_DeactivateRestaurantMutationVariables,
} from '@/types';
import { USER_QUERY } from '@/contexts/user-context-queries';

export const SUPPLIER_DEACTIVATE_RESTAURANT_MUTATION = gql`
  mutation Supplier_DeactivateRestaurant(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    supplierDeactivateRestaurant(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      success
    }
  }
`;

export const useSupplierRemoveRestaurant = () => {
  const [
    supplierDeactivateRestaurant,
    {
      loading: isRestaurantBeingRemoved,
      data: removeRestaurantSuccess,
      error: removeRestaurantError,
    },
  ] = useMutation<
    Supplier_DeactivateRestaurantMutation,
    Supplier_DeactivateRestaurantMutationVariables
  >(SUPPLIER_DEACTIVATE_RESTAURANT_MUTATION, {
    awaitRefetchQueries: false,
    refetchQueries: [getOperationName(USER_QUERY) as string],
  });

  const removeRestaurant = async (
    restaurantUUID: string,
    supplierUUID: string,
  ) => {
    await supplierDeactivateRestaurant({
      variables: {
        restaurantUUID,
        supplierUUID,
      },
    });
  };

  const removeRestaurantWithAlert = async (
    restaurantUUID: string,
    restaurantName: string,
    supplierUUID: string,
    onRemove?: () => void,
  ) => {
    Alert.alert(
      i18n.t('remove_prospect.title', {
        prospectName: restaurantName,
      }),
      i18n.t('remove_prospect.message', {
        prospectName: restaurantName,
      }),
      [
        {
          onPress: async () => {
            onRemove?.();
            await removeRestaurant(restaurantUUID, supplierUUID);
          },
          style: 'destructive',
          text: i18n.t('remove_prospect.button'),
        },
        {
          onPress: () => {},
          style: 'cancel',
          text: i18n.t('cancel'),
        },
      ],
    );
  };

  return {
    isRestaurantBeingRemoved,
    removeRestaurant,
    removeRestaurantError,
    removeRestaurantSuccess,
    removeRestaurantWithAlert,
  };
};
